import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type DynamicData } from "@common/components/Bank/Recipient/AddUpdateModal";
import { type Api } from "@common/declarations";
import { type Account } from "@common/modules/account/types";
import { type MemberWallet } from "./types";

export default {
  init: (apiInfo: ModuleApiInfo): Promise<HttpApiResponse<MemberWallet.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/wallets`),
  createAccount: (
    apiInfo: ModuleApiInfo,
    args: MemberWallet.Api.CreateUpdateAccountRequest
  ): Promise<HttpApiResponse<MemberWallet.Api.CreateUpdateAccountResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/member/wallets/accounts`, args),
  updateAccount: (
    apiInfo: ModuleApiInfo,
    args: MemberWallet.Api.CreateUpdateAccountRequest
  ): Promise<HttpApiResponse<MemberWallet.Api.CreateUpdateAccountResponse>> =>
    api.put(apiInfo, `/api/site/v1/modules/member/wallets/accounts`, args),
  createRecipient: (
    apiInfo: ModuleApiInfo,
    args: MemberWallet.Api.CreateRecipientRequest
  ): Promise<HttpApiResponse<MemberWallet.Api.Beneficiary>> =>
    api.post(apiInfo, `/api/site/v1/modules/member/wallets/recipients`, args),
  getRecipients: (apiInfo: ModuleApiInfo): Promise<HttpApiResponse<MemberWallet.Api.Beneficiary[]>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/wallets/recipients`),
  updateRecipient: (
    apiInfo: ModuleApiInfo,
    args: MemberWallet.Api.UpdateRecipientRequest
  ): Promise<HttpApiResponse<MemberWallet.Api.Beneficiary>> =>
    api.put(apiInfo, `/api/site/v1/modules/member/wallets/recipients`, args),
  getRecipientDynamicData: (
    apiInfo: ModuleApiInfo,
    data: Account.Api.GetBeneficiaryDynamicDataRequest
  ): Promise<HttpApiResponse<DynamicData>> =>
    api.post(apiInfo, `/api/site/v1/modules/member/wallets/recipients/dynamic/data`, data),
  transfer: (
    apiInfo: ModuleApiInfo,
    id: string,
    args: MemberWallet.Api.TransferRequest
  ): Promise<HttpApiResponse<MemberWallet.Api.TransferResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/member/wallets/accounts/${id}/transfer`, args),
  getAccountTransactions: (
    apiInfo: ModuleApiInfo,
    accountId: string,
    args: Api.PageRequest
  ): Promise<HttpApiResponse<Account.Api.AccountTransaction[]>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/wallets/${accountId}/transactions`, args),
  exportTransactions: (apiInfo: ModuleApiInfo, accountId: string, date: Date): Promise<any> =>
    api.download(apiInfo, `/api/site/v1/modules/member/wallets/${accountId}/export/transactions`, { date })
};
